import React from "react";
import "../HomeProcess.css";

import {
    FiClipboard,
    FiLayers,
    FiPenTool,
    FiCode,
    FiCheckCircle,
    FiUploadCloud,
    FiHeadphones,
} from "react-icons/fi";

const process = [
    {
        number: "01",
        icon: <FiClipboard />,
        title: "Requirement Analysis",
        description:
            "We understand your business goals, challenges, and project requirements to build the right solution.",
    },
    {
        number: "02",
        icon: <FiLayers />,
        title: "Planning & Strategy",
        description:
            "Our experts prepare the project roadmap, technology stack, and execution strategy.",
    },
    {
        number: "03",
        icon: <FiPenTool />,
        title: "UI / UX Design",
        description:
            "We create modern, user-friendly interfaces focused on usability and customer experience.",
    },
    {
        number: "04",
        icon: <FiCode />,
        title: "Development",
        description:
            "Our developers build secure, scalable, and high-performance web and mobile applications.",
    },
    {
        number: "05",
        icon: <FiCheckCircle />,
        title: "Testing & Quality",
        description:
            "Every feature is thoroughly tested to ensure security, performance, and reliability.",
    },
    {
        number: "06",
        icon: <FiUploadCloud />,
        title: "Deployment",
        description:
            "We launch your project with proper optimization, security, and production readiness.",
    },
    {
        number: "07",
        icon: <FiHeadphones />,
        title: "Support & Growth",
        description:
            "Continuous maintenance, upgrades, and technical support help your business grow.",
    },
];

const HomeProcess = () => {
    return (
        <section className="home-process">

            <div className="container">

                <div className="process-heading">

                    <span className="process-badge">
                        Our Development Process
                    </span>

                    <h2>
                        From <span>Idea</span> to Successful
                        <span> Digital Transformation</span>
                    </h2>

                    <p>
                        We follow a structured development process to deliver
                        reliable, scalable, and high-quality digital solutions.
                        Every stage is carefully planned to ensure your project
                        is completed on time with exceptional performance.
                    </p>

                </div>

                <div className="process-grid">

                    {process.map((item, index) => (

                        <div
                            className="process-card"
                            key={index}
                        >

                            <span className="process-number">
                                {item.number}
                            </span>

                            <div className="process-icon">
                                {item.icon}
                            </div>

                            <h3>{item.title}</h3>

                            <p>{item.description}</p>

                        </div>

                    ))}

                </div>

            </div>

        </section>
    );
};

export default HomeProcess;